<template lang="pug">
ib-col(class="fixed-flex insety-16 inset-16 border-bottom")
    label(class="bold bond-title fg70") CUSIP Search:&ensp;
    div(class="xl12 l12 m12 s12 flex-flex after-16")
        div(class="matdate")
            form(
                 class="cp-flex",
                 id="cusip-form",
                 @submit.prevent="getCusip"
            )
                ib-field(
                    class="cusip-field cusip-form-input outset-4",
                    name="cusip",
                    v-model="cusip",
                    :placeholder="$t('search_by_cusip')",
                    :maxlength="9"
                )
                ib-button-submit(
                    :disabled="disabled",
                    class="cusip-field outsety-4"
                ) {{ $t('view_results') }}
</template>

<script>
    import api from '../api/'
    import { scanner } from '../js/Scanner'

    export default {
        name: 'CusipSearch',

        props: ['resetCusip'],

        data() {
            return {
               conid: '',
               cusip: '',
               disabled: true,
               invalidInput: false,
               scanner: scanner,
               token: "SZYTKVF48CXA"
           }
        },

        methods: {
            getCusip() {
                api.getConId(this.cusip, this.token)
                    .then(res => {
                        this.conid = res['conids'].length === 0 ? "0" : res['conids'][0];
                        this.cusip = this.cusip.toUpperCase();
                        this.$emit('setFilters',  this.conid, this.cusip, JSON.parse(JSON.stringify(scanner)));
                    })
                    .catch(error => console.log(error))
            },
            holdSubmit(val) {
                if (val === '') {
                    this.disabled = true;
                    return;
                }
                this.invalidInput = /[\W]/.test(val) ? true : false;
                if (this.invalidInput) {
                    this.disabled = true;
                } else if (!this.invalidInput && val.length != 9) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
            },
            reset() {
                this.conid = '';
                this.cusip = '';
                this.disabled = false;
                this.invalidInput = false;
                this.$emit('setFilters',  this.conid, this.cusip, JSON.parse(JSON.stringify(scanner)));
            }
        },

        mounted() {
            this.cusip = this.resetCusip ? this.resetCusip : '';
        },

        watch: {
            cusip: {
                handler(val) {
                    this.holdSubmit(val);
                }
            }
        }
    }
</script>

<style lang="less">
.cusip-field {
    height: 2rem;
}
.cusip-form-input {
    width: 20ch;
    input {
        text-transform: uppercase;
    }
}
</style>
